import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Snackbar from '@material-ui/core/Snackbar';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import CircularProgress from '@material-ui/core/CircularProgress';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import Avatar from '@material-ui/core/Avatar';
import { Helmet } from 'react-helmet';

import NavBar from '../nav/NavBar';
import Footer from '../footer/Footer';
import FooterSpacer from '../footer/FooterSpacer';
import { getClass } from '../../shared/requests/ClassRequests';
import { getUserProfile } from '../../shared/requests/UserInfoRequests';
import MySnackbarContentWrapper from '../../shared/snackbars/MySnackbarContentWrapper';
import profilePlaceholder from '../../static/img/profile_placeholder.png';
import { classTypeMap, classIconMap } from '../../shared/Mappings';
import {
  convert24to12hourtime,
  createProfileRoute,
  getReadableAttendanceTypeByCode,
  truncate,
} from '../../shared/Helpers';
import { GOOGLE_MAPS_NAV_LINK } from '../../shared/Constants';

const styles = theme => ({
  appBarSpacer: theme.mixins.toolbar,
  page: {
    position: 'relative',
    width: '100%',
    minHeight: '100vh',
  },
  header: {
    textAlign: 'center',
    margin: theme.spacing(5),
  },
  loadingSpinner: {
    margin: theme.spacing(5),
  },
  paper: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    [theme.breakpoints.up(800 + theme.spacing(6))]: {
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(6),
    },
  },
  container: {
    width: 'auto',
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    [theme.breakpoints.up(800 + theme.spacing(4))]: {
      width: 800,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  gridPadding: {
    padding: theme.spacing(3),
  },
  button: {
    marginTop: theme.spacing(),
    marginRight: theme.spacing(),
  },
  classTypeIcon: {
    padding: theme.spacing(2.5),
    width: '100%',
  },
  link: {
    textDecoration: 'none',
    textTransform: 'uppercase',
  },
  timezoneNote: {
    paddingTop: theme.spacing(0.5),
    fontSize: 12,
  },
  heading: {
    color: theme.palette.text.secondary,
    letterSpacing: 2,
    textTransform: 'uppercase',
    padding: theme.spacing(),
  },
  classImg: {
    marginTop: theme.spacing(),
    width: 'auto',
    height: '200px',
    borderRadius: '10px',
    margin: '0 auto',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
  },
  subHeader: {
    fontSize: 18,
    marginBottom: theme.spacing(),
    letterSpacing: '1px',
    textTransform: 'uppercase',
  },
  classTypeHeader: {
    fontWeight: 400,
    fontSize: 32,
    letterSpacing: '1px',
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    textTransform: 'uppercase',
  },
  headerContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  borderRight: {
    [theme.breakpoints.up(600)]: {
      borderRight: '1px solid rgba(0, 0, 0, 0.2)',
    },
  },
  h3: {
    letterSpacing: '0.05em',
    textTransform: 'uppercase',
    fontSize: 14,
    marginBottom: theme.spacing(),
  },
  sectionContent: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  iconButton: {
  },
  profileImg: {
    height: '100px',
    width: '100px',
  },
  center: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
});

class ClassPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      snackbarOpen: false,
      snackbarVariant: '',
      snackbarMessage: '',
      niaclass: {},
      user: {},
    };

    this.handleClose = this.handleClose.bind(this);
  }

  componentDidMount() {
    const { id } = this.props.match.params;
    // get class data
    getClass(id)
      .then((response) => {
        console.log('got class: ', response.data);
        this.setState({
          niaclass: response.data,
        });
        getUserProfile(response.data.user.id)
          .then((response2) => {
            // console.log('got user info: ', response2.data);
            this.setState({ user: response2.data, loading: false });
          })
          .catch((error2) => {
            console.log('failed to get user profile');
            console.log(error2);
            if (error2.response.status === 403) {
              this.setState({ loading: false });
            } else {
              this.setState({
                loading: false,
                snackbarOpen: true,
                snackbarVariant: 'error',
                snackbarMessage: 'Failed to load user data.. please refresh the page',
              });
            }
          });
      })
      .catch((error) => {
        // failed to load class
        console.log('failed to get class');
        console.log(error);
        this.setState({
          snackbarOpen: true,
          snackbarVariant: 'error',
          snackbarMessage: 'Failed to load class data.. please refresh the page',
        });
      });
  }

  handleClose(e, reason) {
    if (reason === 'clickaway') {
      return;
    }
    this.setState({ snackbarOpen: false });
  }

  render() {
    const { classes } = this.props;
    const {
      niaclass,
      loading,
      snackbarVariant,
      snackbarMessage,
      snackbarOpen,
      user,
    } = this.state;

    function renderTitle(theniaclass) {
      // console.log(theniaclass.location !== null);
      if (theniaclass.location !== null) {
        return classTypeMap[theniaclass.class_type] + ' Class | ' + theniaclass.location.title;
      }
      return classTypeMap[theniaclass.class_type] + ' Class | Online';
    }

    function renderImg(theuser) {
      if (!theuser.userInfo) {
        return profilePlaceholder;
      }
      return theuser.userInfo.profile_img;
    }

    function renderUsername(theuser) {
      if (!theuser.username) {
        return <Typography>User is set to private</Typography>;
      }
      return (
        <a className={classes.link} href={createProfileRoute(theuser.username)}>
          <Typography color="textSecondary">
            {theuser.first_name + ' ' + theuser.last_name}
          </Typography>
        </a>
      );
    }

    return (
      <div className={classes.page}>
        <NavBar />
        <main className={classes.container}>
          <div className={classes.appBarSpacer} />
          <Typography className={classes.header} color="textSecondary" variant="h4">Class Details</Typography>
          <Paper className={classes.paper} elevation={1}>
            {loading
              ? <CircularProgress color="secondary" className={classes.loadingSpinner} />
              : (
                <Grid container>

                  <Helmet>
                    <title>{renderTitle(niaclass)}</title>
                    <meta name="description" content={truncate(niaclass.description, 200)} />
                    <meta name="keywords" content={classTypeMap[niaclass.class_type] + ', class'} />
                  </Helmet>

                  {/* CLASS IMAGE */}
                  <Grid item xs={12} sm={4} className={classes.gridPadding}>
                    <div
                      style={{ backgroundImage: niaclass.img ? 'url("' + niaclass.img + '")' : 'url("' + profilePlaceholder + '")' }}
                      className={classes.classImg}
                    />
                  </Grid>

                  {/* CLASS TYPE + ATTENDANCE */}
                  <Grid item xs={12} sm={8} className={classNames(classes.gridPadding, classes.headerContainer)}>
                    <Grid container>
                      <Grid item xs={8}>
                        <Typography variant="h1" className={classes.classTypeHeader}>{classTypeMap[niaclass.class_type]}</Typography>
                        <Typography variant="h2" color="textSecondary" className={classes.subHeader}>{getReadableAttendanceTypeByCode(niaclass.attendance_type)}</Typography>
                        {niaclass.link && (
                          <Button target="_blank" href={niaclass.link} className={classes.button} variant="contained" color="secondary">Join/Register</Button>
                        )}
                      </Grid>
                      <Grid item xs={4}>
                        <img src={classIconMap[niaclass.class_type]} alt="nia class type icon" className={classes.classTypeIcon} />
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid item xs={12}>
                    <Divider />
                  </Grid>

                  <Grid item xs={12} sm={4} className={classNames(classes.borderRight, classes.gridPadding)}>
                    {/* USER */}
                    <div className={classNames(classes.sectionContent, classes.center)}>
                      <IconButton href={createProfileRoute(user.username)} className={classes.iconButton}>
                        <Avatar
                          className={classes.profileImg}
                          src={renderImg(user)}
                          title={user.first_name + ' ' + user.last_name}
                        />
                      </IconButton>
                      {renderUsername(user)}
                    </div>
                    {/* LOCATION */}
                    {niaclass.location
                      ? (
                        <React.Fragment>
                          <div className={classes.sectionContent}>
                            <Typography className={classes.h3} variant="h3" color="textSecondary">Location</Typography>
                            <Typography>{niaclass.location.title}</Typography>
                            <Typography>{niaclass.location.address}</Typography>
                          </div>
                          <Button href={'/location/' + niaclass.location.id} variant="outlined" className={classes.button} color="secondary">Location Details</Button>
                          <Button target="_blank" href={GOOGLE_MAPS_NAV_LINK + encodeURIComponent(niaclass.location.address)} className={classes.button} variant="outlined" color="secondary">Get Directions</Button>
                        </React.Fragment>
                      )
                      : (
                        <React.Fragment>
                          <div className={classes.sectionContent}>
                            <Typography variant="h3" color="textSecondary" className={classes.h3}>Online Class</Typography>
                            <Typography>{'This class takes place in the ' + niaclass.timezone + ' timezone.'}</Typography>
                          </div>
                        </React.Fragment>
                      )
                    }
                  </Grid>
                  <Grid item xs={12} sm={8} className={classes.gridPadding}>
                    {/* COST */}
                    <div className={classes.sectionContent}>
                      <Typography variant="h3" color="textSecondary" className={classes.h3}>Description</Typography>
                      <Typography variant="body1">{niaclass.description}</Typography>
                    </div>
                    {/* DESCRIPTION */}
                    <div className={classes.sectionContent}>
                      <Typography variant="h3" color="textSecondary" className={classes.h3}>Cost</Typography>
                      <Typography variant="body1">{niaclass.cost}</Typography>
                    </div>
                    {/* SCHEDULE */}
                    <div className={classes.sectionContent}>
                      <Typography variant="h3" color="textSecondary" className={classes.h3}>Schedule (Local)</Typography>
                      <React.Fragment>
                        {niaclass.monday
                          && <Typography>{`Monday: ${convert24to12hourtime(niaclass.monday_start)} to ${convert24to12hourtime(niaclass.monday_end)}`}</Typography>
                        }
                        {niaclass.tuesday
                          && <Typography>{`Tuesday: ${convert24to12hourtime(niaclass.tuesday_start)} to ${convert24to12hourtime(niaclass.tuesday_end)}`}</Typography>
                        }
                        {niaclass.wednesday
                          && <Typography>{`Wednesday: ${convert24to12hourtime(niaclass.wednesday_start)} to ${convert24to12hourtime(niaclass.wednesday_end)}`}</Typography>
                        }
                        {niaclass.thursday
                          && <Typography>{`Thursday: ${convert24to12hourtime(niaclass.thursday_start)} to ${convert24to12hourtime(niaclass.thursday_end)}`}</Typography>
                        }
                        {niaclass.friday
                          && <Typography>{`Friday: ${convert24to12hourtime(niaclass.friday_start)} to ${convert24to12hourtime(niaclass.friday_end)}`}</Typography>
                        }
                        {niaclass.saturday
                          && <Typography>{`Saturday: ${convert24to12hourtime(niaclass.saturday_start)} to ${convert24to12hourtime(niaclass.saturday_end)}`}</Typography>
                        }
                        {niaclass.sunday
                          && <Typography>{`Sunday: ${convert24to12hourtime(niaclass.sunday_start)} to ${convert24to12hourtime(niaclass.sunday_end)}`}</Typography>
                        }
                        <Typography className={classes.timezoneNote}>{niaclass.timezone && '(Times in ' + niaclass.timezone + ')'}</Typography>
                      </React.Fragment>
                    </div>
                  </Grid>
                </Grid>
              )
            }
          </Paper>

          {/* SNACKBAR */}
          <Snackbar
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
            open={snackbarOpen}
            autoHideDuration={5000}
            onClose={this.handleClose}
          >
            <MySnackbarContentWrapper
              onClose={this.handleClose}
              variant={snackbarVariant}
              message={snackbarMessage}
            />
          </Snackbar>
          <FooterSpacer />
        </main>
        <Footer />
      </div>
    );
  }
}

ClassPage.propTypes = {
  match: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ClassPage);
